import BusinessGstSection from './sections/BusinessGstSection';
import BusinessBankSection from './sections/BusinessBankSection';
import BusinessSaveAction from './sections/BusinessSaveAction';

const BusinessTab = () => {
  return (
    <div className="bg-white p-6 sm:p-8 rounded-3xl border border-gray-100 shadow-sm space-y-6">
      {/* 1. GST Details */}
      <BusinessGstSection />

      {/* 2. Bank Details */}
      <BusinessBankSection />

      {/* 3. Save Business Action */}
      <BusinessSaveAction />
    </div>
  );
};

export default BusinessTab;
